import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
import ThemeContext from "../../context/ThemeContext";
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';


const GET_POST = gql`
query MyQuery($userName: String!) {
    tbl_user_detail(where: { user_name: { _eq: $userName } }) {
        user_name
        name
        last_name
        user_type
        firm_main_code
        firm_sub_code
        dpr_main_code
        dpr_sub_code
        user_lang
        data_lang
        mail_address
        in_line_phone

    }
    tbl_login(where: { user_name: {_eq: $userName}}) {
        user_name
        pass
        active
       
      }
  }
 
`; 

const GET_MDPR = gql`
query MyQuery($firmSubCode: String!) {
    tbl_dpr_main(where: { firm_sub_code: { _eq: $firmSubCode} }) {
        firm_main_code
        firm_sub_code
        lang
        dpr_main_code
        dpr_main_name
      
    }
   
  }
 
`; 
const GET_SDPR = gql`
query GetSdprData($firmSubCode: String!, $dprMainCode: String!) {
    tbl_dpr_sub(where: { firm_sub_code: { _eq: $firmSubCode }, dpr_main_code: { _eq: $dprMainCode } }) {
        firm_main_code
        firm_sub_code
        lang
        dpr_main_code
        dpr_sub_code
        dpr_sub_name
      
    }
   
  }
 
`; 

const UPDATE_FIRM = gql`
  mutation UpdateFirm(
    $userName: String!
    $name: String!
    $lastName: String!
    $userType: String!
    $dprMainCode: String!
    $dprSubCode: String!
    $userLang: String!
    $dataLang: String!
    $mailAddress: String!

  ) {
    update_tbl_user_detail(
      where: { user_name: { _eq: $userName } },
      _set: { user_name: $userName, name: $name, last_name: $lastName, 
        user_type: $userType, dpr_main_code: $dprMainCode, dpr_sub_code: $dprSubCode,
        user_lang: $userLang, data_lang: $dataLang, mail_address: $mailAddress}
    ) {
      affected_rows
    }
  }
`;

const UPDATE_LOGIN = gql`
  mutation UpdateLogin(
    $userName: String!
    $pass: String!
    $active: Boolean!
    

  ) {
    update_tbl_login(
      where: { user_name: { _eq: $userName } },
      _set: { user_name: $userName, pass: $pass, active: $active}
    ) {
      affected_rows
    }
  }
`;



const FirmSubUpdate = () => {


const {theme, setTheme} = useContext(ThemeContext);



  const { user_name } = theme;
  console.log(theme);
  const { loading, error, data } = useQuery(GET_POST, {
    variables: { userName: theme },
  });
  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [UpdateLogin] = useMutation(UPDATE_LOGIN);

  const firmData = data && data.tbl_user_detail ? data.tbl_user_detail[0] : null;
  
  const [userName, setUserName] = useState(firmData ? firmData.user_name : "");
  const [name, setName] = useState(firmData ? firmData.name : "");
  const [lastName, setLastName] = useState(firmData ? firmData.last_name : "ddd");
  const [userType, setUserType] = useState(firmData ? firmData.user_type : "");
  const [dprMainCode, setDprMainCode] = useState (firmData ? firmData.dpr_main_code: "");
  const [dprSubCode, setDprSubCode] = useState (firmData ? firmData.dpr_sub_code: "");
  const [userLang, setUserLang] = useState (firmData? firmData.user_lang: "");
  const [dataLang, setDataLang] = useState (firmData? firmData.data_lang:"");
  const [mailAddress, setMailAddress] = useState (firmData? firmData.mail_address:"");
  const [firmSubCode, setFirmSubCode] = useState (firmData? firmData.firm_sub_code:"");

  const loginData = data && data.tbl_login ? data.tbl_login[0] : null;

  const tblLoginData = data && data.tbl_login ? data.tbl_login[0] : null;
  


  const [pass, setPass] = useState(tblLoginData ? tblLoginData.pass : "");
  const [active, setActive] = useState(tblLoginData ? tblLoginData.active : false);


  


  //const mdprData = useQuery(GET_MDPR, { variables: { firmSubCode: firmData?.data?.tbl_user_detail[0]?.firm_sub_code || "" } });
  
  const [firmName, setFirmName] = useState("");
  
  const [firmType, setFirmType] = useState("");  
  const [place, setPlace] = useState( "");
  console.log("Firm Data:", firmData);
  const { loading: mdprLoading, error: mdprError, data: mdprData } = useQuery(GET_MDPR, {
    variables: { firmSubCode: firmData ? firmData.firm_sub_code : "" },
  });
  console.log("dpr:", mdprData);

  const { loading: msprLoading, error: msprError, data: sdprData } = useQuery(GET_SDPR, {
    variables: { firmSubCode: firmData ? firmData.firm_sub_code : "", dprMainCode: dprMainCode},
  });
  console.log("dpr:", sdprData);
 


  const userLangSelectItems = [
    {label: 'English', value: 'en'},
    {label: 'Turkish', value: 'tr'},
    {label: 'Russian', value: 'ru'},
    {label: 'German', value: 'de'},
    {label: 'Spanish', value: 'es'},
    {label: 'Dutch', value: 'nl'},
    {label: 'Italian', value: 'it'},
    
    
    
  ];


  const userMdprSelectItems = mdprData && mdprData.tbl_dpr_main
  ? mdprData.tbl_dpr_main.map(item => ({
      label: item.dpr_main_name,
      value: item.dpr_main_code,
    }))
  : [];

  const userSdprSelectItems = sdprData && sdprData.tbl_dpr_sub
  ? sdprData.tbl_dpr_sub.map(item => ({
      label: item.dpr_sub_name,
      value: item.dpr_sub_code,
    }))
  : [];
 




  useEffect(() => {
    if (firmData) {
        setUserName(firmData.user_name);
        setName(firmData.name);
        setLastName(firmData.last_name);
        setUserType(firmData.user_type);
        setDprMainCode(firmData.dpr_main_code);
        setDprSubCode(firmData.dpr_sub_code);
        setUserLang(firmData.user_lang);
        setDataLang(firmData.data_lang);
        setMailAddress(firmData.mail_address);
       
       

        if (data.tbl_login) {
            setPass(tblLoginData.pass);
            setActive(tblLoginData.active);
            console.log("pas:", tblLoginData)
           
        }
    }
  }, [firmData]);

  

  const handleUpdate = () => {
    updateFirm({
      variables: {
        userName: userName,
        name: name,
        lastName: lastName,
        userType: userType,
        dprMainCode: dprMainCode,
        dprSubCode: dprSubCode,
        userLang: userLang,
        dataLang: dataLang,
        mailAddress: mailAddress
      },
    })
      .then(() => {
        window.alert("User Detail updated successfully!");
        handleUpdateLogin();
       
      })
      .catch((error) => {
        console.error("Error updating user detail:", error);
      });
  };

  const handleUpdateLogin = () => {
    UpdateLogin({
      variables: {
        userName: userName,
        pass: pass,
        active: active,
        
      },
    })
      .then(() => {
        window.alert("Login User updated successfully!");
       
      })
      .catch((error) => {
        console.error("Error updating login user:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!firmData) {
    return <p>No firm user data found.</p>;
  }

  

  
  

  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
      <h2 className="mb-4 text-2xl font-semibold leading-tight">User Details</h2>

      <div className="card pt-1 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4 -mb-5">
          <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">User Name</label>
    <InputText className="w-full" 
    id="username" value={userName}
    />
  </div>

  <div className="w-1/4 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full " className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Password</label>
    <Password className="w-full" 
    id="firmname" value={pass} 
    onChange={(e) => setPass(e.target.value)} />
  </div>
  <div className="card  flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col -my-8 ml-0 mb-5 align-items-center block font-medium text-gray-950">Active </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setActive(e.value)} checked={active === true} />
          <label htmlFor="ingredient1" className="ml-2">Active</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setActive(e.value)} checked={active === false} />
          <label htmlFor="ingredient2" className="ml-2">Inactive</label>
      </div>
      </div>
      </div>
  </div>
  <div className="flex gap-4">
          <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Name</label>
    <InputText className="w-full" 
    id="username" value={name}
    onChange={(e) => setName(e.target.value)} />
  </div>

  <div className="w-1/2 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Last Name</label>
    <InputText className="w-full" 
    id="firmname" value={lastName} 
    onChange={(e) => setLastName(e.target.value)} />
    
  </div>
  
  </div>

  <div className="flex gap-4 mt-5 mb-5">
          <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">User Type</label>
    <InputText className="w-full" 
    id="username" value={userType}
    onChange={(e) => setUserType(e.target.value)} />
  </div>
  <div className="w-1/3 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">User Language</label>  
  <Dropdown className="w-full"
  value={userLang} 
  options={userLangSelectItems} 
  onChange={(e) => setUserLang(e.value)}
   placeholder="Select a Language"/>
  </div>
  <div className="w-1/3 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Data Language</label>  
  <Dropdown  className="w-full"
  value={dataLang} 
  options={userLangSelectItems} 
  onChange={(e) => setDataLang(e.value)}
   placeholder="Select a Language"/>
  </div>
   </div>
   <div className="flex gap-4">
       <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Main Department</label>  
  <Dropdown className="w-full"
  value={dprMainCode} 
  options={userMdprSelectItems} 
  onChange={(e) => setDprMainCode(e.value)}
   placeholder="Select a Language"/>
  </div>
  <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Sub Department</label>  
  <Dropdown  className="w-full"
  value={dprSubCode} 
  options={userSdprSelectItems} 
  onChange={(e) => setDprSubCode(e.value)}
   placeholder="Select a Language"/>
  </div>
   
  
  
  </div>
  <div className="flex gap-4 mt-5">
          <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Mail Address</label>
    <InputText className="w-full" 
    id="mail" value={mailAddress}
    onChange={(e) => setMailAddress(e.target.value)} />
  </div>

  <div className="w-1/2 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">In Line Phone</label>
    <InputText className="w-full" 
    id="firmname" value={dprSubCode} 
    onChange={(e) => setDprSubCode(e.target.value)} />
    
  </div>
  </div></p>
            </Fieldset>
        </div>
        <div className="flex gap-4">
        <div className="mt-0 ">
        <Button label="New" aria-label="New" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
          onClick={handleUpdate}  />
          
          </div>

        <div className="mt-0 ">
        <Button label="Save" aria-label="Save" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
          onClick={handleUpdate}  />
          
          </div>
          <div className="mt-0 ">
        <Button label="Update" aria-label="Update" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
          onClick={handleUpdate}  />
          
          </div>
          </div>
</div>
);
};

export default FirmSubUpdate;
